import { render } from "./FileField.vue?vue&type=template&id=3796bbb2"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FileField.vue"]])

export default __exports__